import { useState, useEffect } from "react";
// import BuildingImage1 from "../../Assets/Images/BuildingLogo.png";
import BuildingImage1 from "../../Assets/Images/Building1.png";
import BuildingImage2 from "../../Assets/Images/Building2.png";
import roundLogo from "../../Assets/Images/roundLogo.png";
import Appartment from "../../Assets/Images/apartment.png";
import Duplex from "../../Assets/Images/duplex.png";
import Triplex from "../../Assets/Images/triplex.png";
import Flat from "../../Assets/Images/flats.png";
import hero1 from "../../Assets/Images/hero1.webp";
import hero2 from "../../Assets/Images/hero2.webp";
import hero3 from "../../Assets/Images/hero3.webp";
import "./Hero.css";

const RealEstateHeroSlider = () => {
  const slides = [
    {
      id: 1,
      backgroundImage: hero1,
      buildingImage: BuildingImage1, // Added building image for each slide
      title: "Experience the Future of Modern Living",
      subtitle:
        "Our upcoming real estate project blends cutting-edge architecture, luxury amenities, and a prime location. Featuring elegant homes, lush green spaces, and top-tier facilities—your dream lifestyle is just around the corner.",
    },
    {
      id: 2,
      backgroundImage: hero2,
      buildingImage: BuildingImage2, // Alternating building image
      title: "Luxury Living Where Elegance Thrives",
      subtitle:
        "Indulge in residences that merge timeless elegance with modern innovation. From floor-to-ceiling windows framing breathtaking panoramas to intelligent home systems and bespoke interiors—every detail has been designed for the extraordinary.",
    },
    {
      id: 3,
      backgroundImage: hero3,
      buildingImage: BuildingImage1, // Back to first image for third slide
      title: "Discover A Home Where Dreams Flourish",
      subtitle:
        "Step into a sanctuary of style and sophistication. Each space is crafted with meticulous attention to detail, offering panoramic views, lavish finishes, and the perfect harmony of comfort and grandeur—your ideal home, reimagined.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const propertyTypes = [
    { icon: Appartment, label: "Apartment" },
    { icon: Duplex, label: "Duplex" },
    { icon: Triplex, label: "Triplex" },
    { icon: Flat, label: "Flats" },
  ];

  const foundingYear = 2015;
  const currentYear = new Date().getFullYear();
  const yearsOfExperience = currentYear - foundingYear;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    setTimeout(() => setIsAnimating(false), 800);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
    setTimeout(() => setIsAnimating(false), 800);
  };

  const goToSlide = (index) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex(index);
    setTimeout(() => setIsAnimating(false), 800);
  };

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const currentSlide = slides[currentIndex];

  // Responsive adjustments
  const isMobile = windowWidth < 640;
  const isTablet = windowWidth >= 640 && windowWidth < 1024;
  const isDesktop = windowWidth >= 1024;

  return (
    <div className="relative w-full h-[85vh] min-h-[600px] sm:min-h-[700px] overflow-hidden group">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-in-out"
        style={{ backgroundImage: `url(${currentSlide.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-[#0d0d0d] bg-opacity-70"></div>
      </div>

      <div className="relative z-10 h-full flex items-center">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="text-white">
              {/* Main Title */}
              <h1
                key={`title-${currentIndex}`}
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight sm:leading-relaxed mb-4 sm:mb-6 animate-fade-in-up"
                style={{ animationDelay: "0.2s" }}
              >
                {isMobile ? (
                  <>
                    {currentSlide.title.split(" ").slice(0, 3).join(" ")}{" "}
                    <span className="text-[#FF5E14]">
                      {currentSlide.title.split(" ").slice(3, 5).join(" ")}
                    </span>
                    <br />
                    {currentSlide.title.split(" ").slice(5).join(" ")}
                  </>
                ) : (
                  <>
                    {currentSlide.title.split(" ").slice(0, 3).join(" ")}{" "}
                    <span className="text-[#FF5E14]">
                      {currentSlide.title.split(" ").slice(3, 5).join(" ")}
                    </span>
                    <br />
                    {currentSlide.title.split(" ").slice(5).join(" ")}
                  </>
                )}
              </h1>

              {/* Description */}
              <div
                key={`desc-${currentIndex}`}
                className="border-l-4 border-[#FF5E14] pl-4 sm:pl-6 mb-6 sm:mb-8 animate-fade-in-up"
                style={{ animationDelay: "0.4s" }}
              >
                <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
                  {currentSlide.subtitle}
                </p>
              </div>

              {/* Property Types */}
              <div
                key={`types-${currentIndex}`}
                className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 animate-fade-in-up"
                style={{ animationDelay: "0.6s" }}
              >
                {propertyTypes.map((type, index) => (
                  <div
                    key={type.label}
                    className="bg-white/10 border border-white/20 rounded-lg p-2 sm:p-3 text-center shadow-xl transition-all duration-300 cursor-pointer hover:scale-105"
                    style={{ animationDelay: `${0.8 + index * 0.1}s` }}
                  >
                    <img
                      src={type.icon}
                      alt={type.label}
                      className="mx-auto mb-2 sm:mb-3 h-8 w-8 sm:h-10 sm:w-10"
                    />
                    <span className="text-xs sm:text-sm font-medium text-white">
                      {type.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Content - Building Images and Experience Badge */}
            {isDesktop && (
              <div className="relative hidden lg:block">
                {/* Right Content - Building Images and Experience Badge */}
                <div className="relative flex justify-center items-center mt-8 lg:mt-0">
                  {/* Experience Badge */}
                  <div
                    key={`badge-${currentIndex}`}
                    className="absolute -top-6 sm:top-20 xl:top-28 left-3 sm:left-4 lg:left-1 xl:left-12 bg-white rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 shadow-xl z-20 animate-fade-in-scale"
                    style={{ animationDelay: "0.3s" }}
                  >
                    <div className="flex items-center justify-between gap-2 sm:gap-3">
                      {/* Years of Experience */}
                      <div className="flex flex-col items-start leading-tight">
                        <div className="text-base sm:text-lg md:text-xl font-bold text-gray-800">
                          {yearsOfExperience}+
                        </div>
                        <div className="text-[9px] sm:text-[10px] md:text-xs text-[#FF5E14] font-semibold tracking-wide">
                          YEARS OF EXPERTISE
                        </div>
                      </div>
                      {/* Round Logo */}
                      <div>
                        <img
                          src={roundLogo}
                          alt="Round Logo"
                          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12"
                        />
                      </div>
                    </div>
                  </div>
                  {/* Building Image - Now alternates based on current slide */}
                  <div className="relative flex justify-center">
                    <img
                      key={`building-${currentIndex}`}
                      src={currentSlide.buildingImage}
                      alt="Building"
                      className="h-2/3 w-2/3 object-contain animate-fade-in-scale transition-all duration-800 ease-in-out transform hover:scale-105"
                      style={{
                        animationDelay: "0.5s",
                        filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.3))",
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        disabled={isAnimating}
        className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 z-30 disabled:cursor-not-allowed"
      >
        <svg
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <button
        onClick={nextSlide}
        disabled={isAnimating}
        className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 z-30 disabled:cursor-not-allowed"
      >
        <svg
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>

      {/* Dot Indicators */}
      <div className="absolute bottom-4 sm:bottom-8 left-1/2 -translate-x-1/2 flex space-x-2 sm:space-x-3 z-30">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            disabled={isAnimating}
            className={`transition-all duration-300 rounded-full ${
              currentIndex === index
                ? "bg-[#FF5E14] w-6 h-2 sm:w-8 sm:h-3"
                : "bg-white bg-opacity-50 w-2 h-2 sm:w-3 sm:h-3 hover:bg-opacity-80"
            } disabled:cursor-not-allowed`}
          />
        ))}
      </div>

      {/* Mobile Experience Badge */}
      {/* {!isDesktop && (
        <div
          key={`mobile-badge-${currentIndex}`}
          className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-white rounded-2xl px-6 py-4 shadow-xl z-20 animate-fade-in-scale lg:hidden"
          style={{ animationDelay: "0.3s" }}
        >
          <div className="flex items-center justify-between gap-4">
            <div className="flex flex-col items-start">
              <div className="text-2xl font-bold text-gray-800">
                {yearsOfExperience}+
              </div>
              <div className="text-xs text-[#FF5E14] font-semibold">
                YEARS OF EXPERTISE
              </div>
            </div>
            <div>
              <img src={roundLogo} alt="Round Logo" className="w-14 h-14" />
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default RealEstateHeroSlider;

// import { useState, useEffect } from "react";
// import BuildingImage1 from "../../Assets/Images/BuildingLogo.png";
// import roundLogo from '../../Assets/Images/roundLogo.png';
// import Appartment from "../../Assets/Images/apartment.png";
// import Duplex from "../../Assets/Images/duplex.png";
// import Triplex from "../../Assets/Images/triplex.png";
// import Flat from "../../Assets/Images/flats.png";
// import hero1 from "../../Assets/Images/hero1.webp";
// import hero2 from "../../Assets/Images/hero2.webp";
// import hero3 from "../../Assets/Images/hero3.webp";
// import './Hero.css'

// const RealEstateHeroSlider = () => {
//   // Sample slides data - you can replace with your actual images
//   const slides = [
//     {
//       id: 1,
//       backgroundImage: hero1,
//       title: "Experience the Future of Modern Living",
//       subtitle:
//         "Our upcoming real estate project blends cutting-edge architecture, luxury amenities, and a prime location. Featuring elegant homes, lush green spaces, and top-tier facilities—your dream lifestyle is just around the corner.",
//     },
//     {
//       id: 2,
//       backgroundImage: hero2,
//       title: "Luxury Living Where Elegance Thrives",
//       subtitle:
//         "Indulge in residences that merge timeless elegance with modern innovation. From floor-to-ceiling windows framing breathtaking panoramas to intelligent home systems and bespoke interiors—every detail has been designed for the extraordinary.",
//     },
//     {
//       id: 3,
//       backgroundImage: hero3,
//       title: "Discover A Home Where Dreams Flourish",
//       subtitle:
//         "Step into a sanctuary of style and sophistication. Each space is crafted with meticulous attention to detail, offering panoramic views, lavish finishes, and the perfect harmony of comfort and grandeur—your ideal home, reimagined."
//     }

//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [transitionEnabled, setTransitionEnabled] = useState(true);
//   const [isAnimating, setIsAnimating] = useState(false);

//   const propertyTypes = [
//     { icon: Appartment, label: "Apartment" },
//     { icon: Duplex, label: "Duplex" },
//     { icon: Triplex, label: "Triplex" },
//     { icon: Flat, label: "Flats" }
//   ];

//   const foundingYear = 2015;
//   const currentYear = new Date().getFullYear();
//   const yearsOfExperience = currentYear - foundingYear;

//   const nextSlide = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
//     setTimeout(() => setIsAnimating(false), 800);
//   };

//   const prevSlide = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
//     setTimeout(() => setIsAnimating(false), 800);
//   };

//   const goToSlide = (index) => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentIndex(index);
//     setTimeout(() => setIsAnimating(false), 800);
//   };

//   // Auto-play functionality
//   useEffect(() => {
//     const interval = setInterval(() => {
//       nextSlide();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const currentSlide = slides[currentIndex];

//   return (
//     <div className="relative w-full h-[85vh] overflow-hidden group">
//       {/* Background Image with Overlay */}
//       <div
//         className="absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-in-out"
//         style={{ backgroundImage: `url(${currentSlide.backgroundImage})` }}
//       >
//         <div className="absolute inset-0 bg-[#0d0d0d] bg-opacity-70"></div>
//       </div>

//       <div className="relative z-10 h-full flex items-center">
//         <div className="container mx-auto">
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             {/* Left Content */}
//             <div className="text-white">
//               {/* Main Title */}
//               <h1
//                 key={`title-${currentIndex}`}
//                 className="text-4xl lg:text-6xl font-bold leading-relaxed mb-6 animate-fade-in-up"
//                 style={{ animationDelay: '0.2s' }}
//               >
//                 {currentSlide.title.split(' ').slice(0, 3).join(' ')}{' '}
//                 <span className="text-[#FF5E14]">
//                   {currentSlide.title.split(' ').slice(3, 5).join(' ')}
//                 </span>
//                 <br />
//                 {currentSlide.title.split(' ').slice(5).join(' ')}
//               </h1>

//               {/* Description */}
//               <div
//                 key={`desc-${currentIndex}`}
//                 className="border-l-4 border-[#FF5E14] pl-6 mb-8 animate-fade-in-up"
//                 style={{ animationDelay: '0.4s' }}
//               >
//                 <p className="text-lg text-gray-300 leading-relaxed">
//                   {currentSlide.subtitle}
//                 </p>
//               </div>

//               {/* Property Types */}
//               <div
//                 key={`types-${currentIndex}`}
//                 className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 animate-fade-in-up"
//                 style={{ animationDelay: '0.6s' }}
//               >
//                 {propertyTypes.map((type, index) => (
//                   <div
//                     key={type.label}
//                     className="bg-white/10 border border-white/20  rounded-lg p-3 text-center shadow-xl transition-all duration-300 cursor-pointer hover:scale-105"
//                     style={{ animationDelay: `${0.8 + index * 0.1}s` }}
//                   >
//                     <img src={type.icon} alt={type.label} className="mx-auto mb-3 h-10 w-10" />
//                     <span className="text-sm font-medium text-white">{type.label}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Right Content - Building Images and Experience Badge */}
//             <div className="relative">
//               <div
//                 key={`badge-${currentIndex}`}
//                 className="absolute -top-4 left-8 bg-white rounded-2xl px-6 py-4 shadow-xl z-20 animate-fade-in-scale"
//                 style={{ animationDelay: '0.3s' }}
//               >
//                 <div className="flex items-center justify-between gap-4">
//                   {/* Left Side: Number + Text */}
//                   <div className="flex flex-col items-start">
//                     <div className="text-2xl font-bold text-gray-800">{yearsOfExperience}+</div>
//                     <div className="text-xs text-[#FF5E14] font-semibold">YEARS OF EXPERTISE</div>
//                   </div>

//                   {/* Right Side: Logo */}
//                   <div>
//                     <img src={roundLogo} alt="Round Logo" className="w-14 h-14" />
//                   </div>
//                 </div>
//               </div>

//               {/* Building Images Container */}
//               <div className="relative">
//                 {/* Orange Hexagonal Shapes */}
//                 <div className="absolute inset-0 z-10">
//                   <div className="absolute -top-28 -right-8 animate-bounce">
//                     <img src={BuildingImage1} alt="Building 1" />
//                   </div>
//                 </div>

//                 {/* Spacer to maintain layout */}
//                 <div className="h-96 w-full"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Navigation Buttons */}
//       <button
//         onClick={prevSlide}
//         disabled={isAnimating}
//         className="absolute left-6 top-1/2 -translate-y-1/2 bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white p-3 rounded-full shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 z-30 disabled:cursor-not-allowed"
//       >
//         <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//         </svg>
//       </button>

//       <button
//         onClick={nextSlide}
//         disabled={isAnimating}
//         className="absolute right-6 top-1/2 -translate-y-1/2 bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white p-3 rounded-full shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 z-30 disabled:cursor-not-allowed"
//       >
//         <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//         </svg>
//       </button>

//       {/* Dot Indicators */}
//       <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-30">
//         {slides.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => goToSlide(index)}
//             disabled={isAnimating}
//             className={`transition-all duration-300 rounded-full ${currentIndex === index
//               ? "bg-[#FF5E14] w-8 h-3"
//               : "bg-white bg-opacity-50 w-3 h-3 hover:bg-opacity-80"
//               } disabled:cursor-not-allowed`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default RealEstateHeroSlider;

// import React from "react";
// import houseIcon from "../../Assets/Images/Mask_group.png";
// import MainImage from "../../Assets/Images/HeroSectionImage.png";
// import HeroSectionBg from "../../Assets/Images/HeroBg.png";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useEffect } from "react";

// export default function HeroSection() {
//   const propertyTypes = [
//     { id: 1, type: "Simplex", icon: houseIcon },
//     { id: 2, type: "Duplex", icon: houseIcon },
//     { id: 3, type: "Triplex", icon: houseIcon },
//     { id: 4, type: "Villa", icon: houseIcon },
//   ];

//   useEffect(() => {
//     // Initialize AOS with once: true to prevent repeated animations
//     AOS.init({
//       duration: 800,
//       easing: "ease-in-out",
//       once: false, // Animation happens only once
//       offset: 100, // Trigger animation 100px before element comes into view
//       delay: 0,
//     });

//     // Cleanup function to refresh AOS on component unmount
//     return () => {
//       AOS.refresh();
//     };
//   }, []);

//   return (
//     <div className="min-h-screen  relative overflow-hidden">
//       {/* Background Image with Dark Overlay */}
//       <div
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat"
//         style={{
//           backgroundImage: `url(${HeroSectionBg})`,
//         }}
//         data-aos="zoom-in"
//       >
//         <div className="absolute inset-0 bg-black bg-opacity-40"></div>
//       </div>

//       {/* Background Pattern */}
//       <div className="absolute inset-0 opacity-10">
//         <div className="absolute top-20 right-1/4 w-32 h-32 bg-white rounded-full"></div>
//         <div className="absolute bottom-32 left-1/3 w-24 h-24 bg-white rounded-full"></div>
//         <div className="absolute top-1/2 right-1/2 w-16 h-16 bg-white rounded-full"></div>
//       </div>

//       <div className="flex min-h-screen relative z-10">
//         {/* Left Side - Content */}
//         <div className="w-full lg:w-1/2 flex items-center justify-start p-4 sm:p-6 md:p-8 lg:p-12 xl:p-16">
//           <div className="max-w-lg xl:max-w-xl space-y-6 sm:space-y-8">
//             {/* Main Heading */}
//             <div className="space-y-2 sm:space-y-3" data-aos="fade-right">
//               <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black leading-tight drop-shadow-lg">
//                 Search And Find
//               </h1>
//               <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
//                 <span className="text-red-500 drop-shadow-lg">Luxury</span>{" "}
//                 <span className="text-black drop-shadow-lg">House</span>
//               </h1>
//             </div>

//             {/* Description */}
//             <div
//               className="space-y-3 sm:space-y-4 border-l-4 border-gray-300 p-4 bg-black bg-opacity-20 backdrop-blur-sm rounded-r-lg"
//               data-aos="fade-right"
//             >
//               <p className="text-gray-100 text-sm sm:text-base md:text-lg leading-relaxed">
//                 Our Latest Real Estate Development Is Set To Redefine Modern
//                 Living With Cutting-Edge Architecture, Premium Amenities, And A
//                 Prime Location. Designed For Comfort And Sophistication, This
//                 Upcoming Project Will Feature Elegant Residences, Lush Green
//                 Spaces, And State-Of-The-Art Facilities Stay Tuned As We Unveil
//                 A New Era Of Luxury And Convenience —Where Your Dream Home
//                 Becomes A Reality! Coming Soon
//               </p>
//             </div>

//             {/* Property Type Cards */}
//             <div
//               className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 pt-4 sm:pt-6"
//               data-aos="fade-right"
//             >
//               {propertyTypes.map((property) => (
//                 <div
//                   key={property.id}
//                   className="bg-white bg-opacity-95 backdrop-blur-sm rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-3 sm:p-4 flex flex-col items-center space-y-2 sm:space-y-3 border border-gray-100"
//                 >
//                   {/* Icon Container */}
//                   <div
//                     className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center"
//                     data-aos="zoom-in"
//                   >
//                     <div className="text-white text-xs sm:text-sm md:text-base font-bold">
//                       <img src={property.icon} alt="No Image" srcSet="" />
//                     </div>
//                   </div>

//                   {/* Property Type Text */}
//                   <span className="text-gray-800 font-medium text-xs sm:text-sm md:text-base text-center">
//                     {property.type}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Right Side - Property Image */}
//         <div className="hidden lg:block lg:w-1/2 relative" data-aos="fade-left">
//           <div className="h-full w-full relative overflow-hidden p-8">
//             <img
//               src={MainImage}
//               alt="Luxury Real Estate Property"
//               className="w-full h-full object-contain"
//             />
//             {/* Subtle overlay for better text readability if needed */}
//             <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black via-transparent opacity-20"></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
